import axios from "../../../untils/request.js";

// 个人中心 - 我的简历 接口

// 首页 / 根据用户id查询用户所有信息
export async function getUserResumeInfo(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/getUserResumeInfo",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人中心-我的简历-更新用户简历信息（不包含求职意向，工作经历，项目经历，教育经历，证书）
export async function updateUserResumes(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/updateUserResumes",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-添加求职意向
export async function addUserJobIntention(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/addUserJobIntention",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-编辑求职意向
export async function editUserJobIntention(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/editUserJobIntention",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-删除求职意向
export async function deleteUserJobIntention(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/deleteUserJobIntention",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-添加工作经历
export async function addUserWorkExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/addUserWorkExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-编辑工作经历
export async function editUserWorkExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/editUserWorkExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-删除个人工作经历
export async function deleteUserWorkExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/deleteUserWorkExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-添加用户项目经历
export async function addUserProjectExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/addUserProjectExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-编辑用户项目经历
export async function editUserProjectExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/editUserProjectExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-删除用户项目经历
export async function deleteUserProjectExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/deleteUserProjectExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-添加用户教育经历
export async function addUserEducationExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/addUserEducationExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
// 个人简历-编辑用户教育经历
export async function editUserEducationExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/editUserEducationExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-删除用户教育经历
export async function deleteUserEducationExp(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/deleteUserEducationExp",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-添加用户证书
export async function addUserCertificate(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/addUserCertificate",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-编辑用户证书
export async function editUserCertificate(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/editUserCertificate",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 个人简历-删除证书
export async function deleteUserCertificate(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/deleteUserCertificate",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}


// 个人简历-工作经历 - 获取个人自定义技能列表
export async function selectSkill(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/selectSkill",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
// 个人简历-工作经历 - 新增自定义技能
export async function addUserCustomSkill(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/addUserCustomSkill",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
// 个人简历-工作经历 - 删除自定义技能
export async function deleteUserCustomSkill(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/deleteUserCustomSkill",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}